import styles from "./cart-drawer-loading.module.css"

type CartDrawerLoadingProps = {
  variant: "body" | "inline"
  label: string
}

export default function CartDrawerLoading({
  variant,
  label,
}: CartDrawerLoadingProps) {
  return (
    <div
      className={`${styles.root} ${styles[variant]}`}
      data-testid={`cart-drawer-loading-${variant}`}
      role="status"
      aria-live="polite"
    >
      <span className={styles.indicator} aria-hidden="true">
        <span className={styles.spinner} />
      </span>
      <span className={styles.label}>{label}</span>
      <span className={styles.progress} aria-hidden="true" />
    </div>
  )
}
